import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { NotificationMessagesFacade } from '@boma/supplier-portal/notifications';
import { map, take } from 'rxjs/operators';
import { ExcludableList, MessageEventType } from '@boma/shared/entities';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppComponent } from 'apps/supplier-portal/src/app/app.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[notification-messages-list]',
  templateUrl: './notification-messages-list.component.html',
  styleUrls: ['./notification-messages-list.component.scss'],
})
export class NotificationMessagesListComponent implements OnInit, OnDestroy {
  /// True displays the notification messages in an overlay panel which is toggled by a button
  @Input() asOverlayPanel = true;
  @Input() adminPortal;
  @Input() showHeader = true;
  messages$ = this.notificationFacade.messages$;
  nextPage$ = this.notificationFacade.nextPage$;
  unreadMessageCount$: Observable<string> =
    this.notificationFacade.unreadMessageCount$.pipe(
      map((count) => (count > 99 ? '99+' : count ? `${count}` : ''))
    );
  hasMessages$ = this.notificationFacade.messages$.pipe(
    map((messages) => messages?.length)
  );
  appMain: AppComponent;

  page: 1;
  nextPage;

  notificationSubscription: Subscription;

  constructor(
    private notificationFacade: NotificationMessagesFacade,
    private injector: Injector,
    private store: Store
  ) {}

  ngOnInit() {
    if (this.adminPortal !== true) {
      this.appMain = <AppComponent>this.injector.get(AppComponent);
    }

    this.notificationSubscription = this.notificationFacade.nextPage$.subscribe(
      (x) => {
        this.nextPage = x;
      }
    );
  }

  //TODO Need a way to update the notifications bade without reloading
  showOverlayPanel(event) {
    this.appMain.onTopbarNotificationMenuButtonClick(event);
    this.notificationFacade.loadLatestMessages();
  }

  refreshNotifications() {
    this.notificationFacade.loadNotifications({
      page: 1,
      pageSize: 25,
      messageEventTypes: new ExcludableList<MessageEventType>(),
      refresh: true,
    });
  }

  loadNextPage() {
    this.notificationFacade.loadNotifications({
      page: this.nextPage,
      pageSize: 25,
      messageEventTypes: new ExcludableList<MessageEventType>(),
      refresh: false,
    });
  }

  markAllAsRead(): void {
    this.notificationFacade.messages$.pipe(take(1)).subscribe((messages) => {
      const ids = messages.map((m) => m.id);
      this.notificationFacade.unreadMessageCount$.next(0);
      this.notificationFacade.addEventsToMessage(
        ids.map((id) => ({
          messageId: id,
          eventType: MessageEventType.Read,
        }))
      );
    });
  }

  ngOnDestroy(): void {
    this.notificationSubscription?.unsubscribe();
  }
}
